<template>
  <artisan-group title="检索条件">
    <el-form
      ref="gridSearchForm"
      size="mini"
      :model="formData"
      @keyup.enter.native="search"
    >
      <el-row style="transition: all 0.5s ease">
        <el-col v-if="$slots.header" :span="span" :style="{ height }">
          <slot name="header"></slot>
        </el-col>
        <el-col
          :span="span"
          :style="{ height }"
          v-for="(column, index) in columnsOfSearch"
          :key="index"
          style="padding: 0 5px"
        >
          <el-form-item
            label-width="80px"
            :prop="column.code"
            :label="column.name"
          >
            <slot
              v-if="column.searchSlot"
              :column="column"
              :data="formData"
              :name="column.code + 'Search'"
            ></slot>
            <div v-else>
              <template v-if="column.dataType == 'bool'">
                <el-select
                  clearable
                  :filterable="true"
                  style="width: 100%"
                  v-model="formData[column.code]"
                >
                  <el-option value="" label="全部">全部</el-option>
                  <el-option :value="true" label="是"></el-option>
                  <el-option :value="false" label="否"></el-option>
                </el-select>
              </template>
              <template v-else-if="column.inputType == 'radio'">
                <el-radio-group v-model="formData[column.code]">
                  <el-radio>全部</el-radio>
                  <template v-for="(dic, dicIndex) in column.dicData">
                    <el-radio :key="dicIndex" :label="dic.value">{{
                      dic.label
                    }}</el-radio>
                  </template>
                </el-radio-group>
              </template>
              <template v-else-if="column.inputType == 'checkbox'">
                <el-checkbox-group v-model="formData[column.code]">
                  <el-checkbox :key="dicIndex" :label="dic.value">{{
                    dic.label
                  }}</el-checkbox>
                </el-checkbox-group>
              </template>
              <el-input-number
                v-else-if="
                  column.dataType == 'number' && column.inputType == 'input'
                "
                clearable
                v-model="formData[column.code]"
                controls-position="right"
                style="width: 100%"
              ></el-input-number>
              <template v-else-if="column.inputType == 'date'">
                <el-date-picker
                  style="width: 100%"
                  v-model="formData[column.code]"
                  type="daterange"
                  format="yyyy-MM-dd"
                  :default-value="[new Date(), new Date()]"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </template>
              <template v-else-if="column.inputType == 'localdate'">
                <el-date-picker
                  style="width: 100%"
                  v-model="formData[column.code]"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </template>
              <template v-else-if="column.inputType == 'dateyear'">
                <el-date-picker
                  style="width: 100%"
                  v-model="formData[column.code]"
                  type="year"
                  format="yyyy 年"
                  value-format="yyyy"
                  placeholder="选择年"
                ></el-date-picker>
              </template>
              <template v-else-if="column.inputType == 'select'">
                <el-select
                  clearable
                  :filterable="true"
                  style="width: 100%"
                  v-model="formData[column.code]"
                >
                  <el-option
                    v-for="dic in column.dicData"
                    :key="dic.value"
                    :label="dic.label"
                    :value="dic.value"
                  ></el-option>
                </el-select>
              </template>
              <template v-else-if="column.inputType == 'mutiselect'">
                <el-select
                  clearable
                  style="width: 100%"
                  v-model="formData[column.code]"
                  multiple
                >
                  <el-option
                    v-for="dic in column.dicData"
                    :key="dic.value"
                    :label="dic.label"
                    :value="dic.value"
                  ></el-option>
                </el-select>
              </template>
              <template v-else-if="column.inputType == 'treeselect'">
                <el-cascader
                  style="width: 100%"
                  v-model="formData[column.code]"
                  :options="column.treeData"
                  :props="{
                    checkStrictly: true,
                    expandTrigger: 'hover',
                    emitPath: false,
                  }"
                  clearable
                ></el-cascader>
              </template>
              <template v-else>
                <el-input v-model="formData[column.code]" clearable></el-input>
              </template>
            </div>
          </el-form-item>
        </el-col>
        <el-col v-if="$slots.footer" :span="span" :style="{ height }">
          <slot name="footer"></slot>
        </el-col>
      </el-row>
      <div style="text-align: center">
        <el-button
          size="mini"
          type="primary"
          @click="search"
          icon="el-icon-search"
          class="margin-h5"
        >
          查询
        </el-button>
        <el-button
          type="warning"
          class="margin-h5"
          size="mini"
          @click="reset"
          icon="el-icon-refresh-left"
        >
          重置
        </el-button>
        <el-button
          v-if="rowCount > 1 && rowCount < columns.length"
          plain
          class="margin-h5"
          size="mini"
          icon="el-icon-more"
          @click="isExpand = !isExpand"
        >
          更多条件
        </el-button>
      </div>
    </el-form>
  </artisan-group>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    span: {
      type: Number,
      default: 12,
    },
    height: {
      type: String,
      default: "40px",
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    let formData = {};
    this.columns.forEach((column) => {
      formData[column.code] = "";
    });
    return {
      formData,
      isExpand: true,
    };
  },
  computed: {
    columnsOfSearch() {
      if (this.isExpand && this.rowSpan != 1) {
        return this.columns.slice(0, this.rowSpan);
      } else {
        return this.columns;
      }
    },
    rowSpan() {
      return parseInt(24 / this.span);
    },
    rowCount() {
      return parseInt(this.columns.length / this.rowSpan);
    },
  },
  watch: {
    formData: {
      handler() {
        this.$emit("input", this.formData);
      },
      deep: true,
    },
  },
  methods: {
    validate(func) {
      this.$refs.gridSearchForm.validate(func);
    },
    reset() {
      this.$refs.gridSearchForm.resetFields();
      let formData = {};
      this.columns.forEach((column) => {
        formData[column.code] = "";
      });
      Object.assign(formData, this.value);
      this.formData = formData;
      this.$emit("search", this.formData);
    },
    search() {
      this.$emit("search", this.formData);
    },
  },
};
</script>

<style scoped></style>
